import { useEffect, useState } from "react";
import api from "../../lib/api";
import { fmtTRY, fmtDate, fmtQty4 } from "../../lib/format";
import { toast } from "sonner";

const STATUSES = ["Yeni Sipariş", "Onay Bekliyor", "Hazırlanıyor", "Kargoya Verildi", "Teslim Edildi", "İptal Edildi", "İade Talebi", "İade Edildi"];
const CARGO = ["Yurtiçi Kargo", "MNG Kargo", "Aras Kargo", "Sürat Kargo", "PTT Kargo", "Hepsijet"];

export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  const [filter, setFilter] = useState("");
  const [kaynak, setKaynak] = useState("");
  const [kanal, setKanal] = useState("");
  const [channels, setChannels] = useState([]);
  const [detail, setDetail] = useState(null);
  const [statusForm, setStatusForm] = useState({ status: "", tracking_number: "", cargo_company: "" });

  const load = () => {
    const p = new URLSearchParams();
    if (filter) p.set("durum", filter);
    if (kaynak) p.set("kaynak", kaynak);
    if (kanal) p.set("kanal", kanal);
    return api.get(`/admin/orders${p.toString() ? `?${p}` : ""}`).then(({ data }) => { setOrders(data); });
  };
  useEffect(() => { api.get("/admin/marketplaces").then(({ data }) => setChannels(data)).catch(() => {}); }, []);
  useEffect(() => { load().catch(() => {}); /* eslint-disable-next-line */ }, [filter]);

  const saveStatus = async () => {
    try {
      await api.put(`/admin/orders/${detail.order_id}/status`, statusForm);
      toast.success("Sipariş güncellendi");
      setDetail(null);
      load();
    } catch { toast.error("Güncellenemedi"); }
  };

  const [addrEdit, setAddrEdit] = useState(null);
  const [noteEdit, setNoteEdit] = useState("");

  const saveAddr = async () => {
    try {
      await api.put(`/admin/orders/${detail.order_id}`, { address: addrEdit, note: noteEdit });
      toast.success("Sipariş bilgileri güncellendi");
      setDetail({ ...detail, address: addrEdit, note: noteEdit });
      setAddrEdit(null);
      load();
    } catch { toast.error("Güncellenemedi"); }
  };

  const deleteOrder = async () => {
    if (!window.confirm(`${detail.order_number} silinsin mi? Kayıt arşivlenir; finansal geçmiş ve raporlar korunur.`)) return;
    try {
      await api.delete(`/admin/orders/${detail.order_id}`);
      toast.success("Sipariş arşivlendi");
      setDetail(null);
      load();
    } catch { toast.error("Silinemedi"); }
  };

  const createInvoice = async () => {
    try {
      const { data } = await api.post(`/admin/orders/${detail.order_id}/create-invoice`);
      toast.success(`Fatura oluşturuldu: ${data.invoice_number}`);
      setDetail({ ...detail, invoice_id: data.invoice_id, invoice_number: data.invoice_number });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Fatura oluşturulamadı"); }
  };

  const inputCls = "w-full h-11 px-4 rounded-xl border border-stone-300 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-forest/30";

  return (
    <div data-testid="admin-orders-page">
      <h1 className="font-serif text-2xl sm:text-3xl text-forest">Siparişler</h1>
      <div className="flex gap-2 mt-5 overflow-x-auto scrollbar-none pb-1">
        <button data-testid="filter-status-all" onClick={() => setFilter("")} className={`px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${!filter ? "bg-forest text-white" : "bg-white border border-stone-300"}`}>Tümü</button>
        {[["", "Tüm Kaynaklar"], ["web", "Site"], ["b2b", "B2B"], ["okc", "ÖKC"], ["pazaryeri", "Pazaryeri"], ...channels.map((c) => [`kanal:${c.channel_id}`, c.name])].map(([v, l]) => (
          <button key={`k-${v}`} data-testid={`filter-source-${v || "all"}`} onClick={() => { if (v.startsWith("kanal:")) { setKaynak(""); setKanal(v.slice(6)); } else { setKaynak(v); setKanal(""); } }} className={`px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${(v.startsWith("kanal:") && kanal === v.slice(6)) || (!v.startsWith("kanal:") && kaynak === v && !kanal) ? "bg-gold text-stone-900" : "bg-white border border-stone-200"}`}>{l}</button>
        ))}
        {STATUSES.map((s) => (
          <button key={s} data-testid={`filter-status-${s}`} onClick={() => setFilter(s)} className={`px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${filter === s ? "bg-forest text-white" : "bg-white border border-stone-300"}`}>{s}</button>
        ))}
      </div>
      <div className="bg-white rounded-2xl border border-stone-200/80 mt-5 overflow-x-auto shadow-sm">
        <table className="w-full text-sm min-w-[760px]">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-stone-400 border-b border-stone-100"><th className="p-4">Sipariş No</th><th className="p-4">Müşteri</th><th className="p-4">Tarih</th><th className="p-4">Ödeme</th><th className="p-4">Durum</th><th className="p-4 text-right">Tutar</th></tr></thead>
          <tbody>
            {(orders || []).map((o) => (
              <tr key={o.order_id} data-testid={`order-row-${o.order_number}`} onClick={() => { setDetail(o); setStatusForm({ status: o.status, tracking_number: o.tracking_number || "", cargo_company: o.cargo_company || "" }); }} className="border-b border-stone-50 hover:bg-cream/60 cursor-pointer">
                <td className="p-4 font-mono text-xs font-bold">{o.order_number}<span data-testid={`order-source-${o.order_number}`} className="block font-sans font-normal text-[10px] text-stone-400 mt-0.5">{{ web: "Site", okc: "ÖKC", b2b: "B2B", pazaryeri: "Pazaryeri" }[o.source] || o.source || "Site"}</span></td>
                <td className="p-4">{o.address?.full_name}<span className="block text-xs text-stone-400">{o.email}</span></td>
                <td className="p-4 text-stone-500">{fmtDate(o.created_at)}</td>
                <td className="p-4 text-xs">{{ havale: "Havale/EFT", kapida: "Kapıda", stripe: "Kart" }[o.payment_method]} · <span className={o.payment_status === "paid" ? "text-green-700 font-semibold" : "text-amber-700"}>{o.payment_status === "paid" ? "Ödendi" : "Bekliyor"}</span></td>
                <td className="p-4"><span className="text-xs bg-cream-dark rounded-full px-2.5 py-1 whitespace-nowrap">{o.status}</span></td>
                <td className="p-4 text-right font-semibold">{fmtTRY(o.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders === null && <p className="p-8 text-center text-stone-400">Yükleniyor...</p>}
        {orders?.length === 0 && <p className="p-8 text-center text-stone-400">Sipariş yok</p>}
      </div>

      {detail && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={() => setDetail(null)}>
          <div data-testid="order-detail-modal" className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6 sm:p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start">
              <div><h2 className="font-mono font-bold text-lg">{detail.order_number}</h2><p className="text-xs text-stone-500 mt-1">{fmtDate(detail.created_at)} · {detail.email}</p></div>
              <button onClick={() => setDetail(null)} className="text-stone-400 hover:text-stone-700 text-xl leading-none">✕</button>
            </div>
            <div className="mt-4 text-sm bg-cream-dark/50 rounded-xl p-4">
              {addrEdit ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <input data-testid="order-edit-name" className={inputCls} value={addrEdit.full_name || ""} onChange={(e) => setAddrEdit({ ...addrEdit, full_name: e.target.value })} placeholder="Ad Soyad" />
                  <input data-testid="order-edit-phone" className={inputCls} value={addrEdit.phone || ""} onChange={(e) => setAddrEdit({ ...addrEdit, phone: e.target.value })} placeholder="Telefon" />
                  <input data-testid="order-edit-city" className={inputCls} value={addrEdit.city || ""} onChange={(e) => setAddrEdit({ ...addrEdit, city: e.target.value })} placeholder="İl" />
                  <input data-testid="order-edit-district" className={inputCls} value={addrEdit.district || ""} onChange={(e) => setAddrEdit({ ...addrEdit, district: e.target.value })} placeholder="İlçe" />
                  <input data-testid="order-edit-address" className={`${inputCls} sm:col-span-2`} value={addrEdit.address || ""} onChange={(e) => setAddrEdit({ ...addrEdit, address: e.target.value })} placeholder="Adres" />
                  <input data-testid="order-edit-postal" className={inputCls} value={addrEdit.postal_code || ""} onChange={(e) => setAddrEdit({ ...addrEdit, postal_code: e.target.value })} placeholder="Posta Kodu" />
                  <input data-testid="order-edit-note" className={inputCls} value={noteEdit} onChange={(e) => setNoteEdit(e.target.value)} placeholder="Sipariş notu" />
                  <div className="sm:col-span-2 flex gap-2">
                    <button data-testid="order-edit-save" onClick={saveAddr} className="flex-1 bg-forest hover:bg-forest-dark text-white text-xs font-bold py-2.5 rounded-lg transition-colors">Kaydet</button>
                    <button data-testid="order-edit-cancel" onClick={() => setAddrEdit(null)} className="px-4 border border-stone-300 text-stone-600 text-xs font-bold py-2.5 rounded-lg hover:bg-stone-50">Vazgeç</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="flex items-start justify-between gap-2">
                    <p className="font-semibold">{detail.address.full_name} · {detail.address.phone}</p>
                    <button data-testid="order-edit-open" onClick={() => { setAddrEdit({ ...detail.address }); setNoteEdit(detail.note || ""); }} className="text-[11px] font-bold text-forest hover:underline shrink-0">Düzenle</button>
                  </div>
                  <p className="text-stone-600 mt-1">{detail.address.address}, {detail.address.district} {detail.address.city}</p>
                  {detail.note && <p className="text-stone-500 text-xs mt-1 italic">Not: {detail.note}</p>}
                </>
              )}
            </div>
            <div className="mt-4 space-y-1.5 text-sm">
              {detail.items.map((i) => (
                <div key={i.product_id + (i.variant || "")} className="flex justify-between"><span>{i.name}{i.variant ? ` (${i.variant})` : ""} × {fmtQty4(i.quantity, i.base_unit || i.unit)}</span><span className="font-medium">{fmtTRY(i.total)}</span></div>
              ))}
              {(() => { let m = 0, k = 0; (detail.items || []).forEach((i) => { const r = (i.vat_rate ?? 1) / 100; const mm = i.total / (1 + r); m += mm; k += i.total - mm; }); return (
                <div className="pt-2 border-t border-stone-100 space-y-1 text-xs text-stone-500" data-testid="order-vat-breakdown">
                  <div className="flex justify-between"><span>Matrah (KDV hariç)</span><span>{fmtTRY(m)}</span></div>
                  <div className="flex justify-between"><span>KDV (fiyatlara dahil)</span><span>{fmtTRY(k)}</span></div>
                </div> ); })()}
              <div className="flex justify-between pt-2 border-t border-stone-100 font-bold"><span>Toplam</span><span>{fmtTRY(detail.total)}</span></div>
            </div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <select data-testid="order-status-select" className={inputCls} value={statusForm.status} onChange={(e) => setStatusForm({ ...statusForm, status: e.target.value })}>
                {STATUSES.map((s) => <option key={s}>{s}</option>)}
              </select>
              <select data-testid="cargo-company-select" className={inputCls} value={statusForm.cargo_company} onChange={(e) => setStatusForm({ ...statusForm, cargo_company: e.target.value })}>
                <option value="">Kargo firması</option>
                {CARGO.map((c) => <option key={c}>{c}</option>)}
              </select>
              <input data-testid="tracking-number-input" className={inputCls} placeholder="Takip numarası" value={statusForm.tracking_number} onChange={(e) => setStatusForm({ ...statusForm, tracking_number: e.target.value })} />
            </div>
            <button data-testid="order-status-save" onClick={saveStatus} className="mt-4 w-full bg-forest hover:bg-forest-dark text-white font-semibold py-3 rounded-xl transition-colors">Durumu Kaydet</button>
            {detail.invoice_number ? (
              <p data-testid="order-invoice-info" className="mt-2 text-center text-xs font-semibold text-sky-700 bg-sky-50 rounded-xl py-2.5">Fatura oluşturuldu: {detail.invoice_number}</p>
            ) : !["İptal Edildi", "İade Edildi"].includes(detail.status) && (
              <button data-testid="order-create-invoice" onClick={createInvoice} className="mt-2 w-full bg-gold hover:bg-gold-dark text-stone-900 font-semibold py-2.5 rounded-xl transition-colors">Fatura Oluştur</button>
            )}
            <button data-testid="order-delete" onClick={deleteOrder} className="mt-2 w-full border border-red-300 text-terra text-sm font-semibold py-2.5 rounded-xl hover:bg-red-50 transition-colors">Siparişi Sil (Arşivle)</button>
            <div className="mt-5">
              <p className="text-xs uppercase tracking-wider text-stone-400 font-semibold">Geçmiş</p>
              <div className="mt-2 space-y-1">
                {(detail.status_history || []).map((h, i) => <p key={i} className="text-xs text-stone-500">{fmtDate(h.at)} — {h.status} ({h.by})</p>)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
